export const SET_EDITIONS = "SET_EDITIONS";
export const SET_EDITIONS_FAILED= "SET_EDITIONS_FAILED";

export const RETRIEVE_SPECIFIC_EDITION_START = "RETRIEVE_EDITION_START";
export const RETRIEVE_SPECIFIC_EDITION_SUCCESS = "RETRIEVE_EDITION_SUCCESS";
export const RETRIEVE_SPECIFIC_EDITION_FAIL = "RETRIEVE_EDITION_FAIL";

export const RETRIEVE_THEMATIC_ARTICLE_LIST_START = 'RETRIEVE_THEMATIC_ARTICLES_START';
export const RETRIEVE_THEMATIC_ARTICLE_LIST_SUCCESS = 'RETRIEVE_THEMATIC_ARTICLES_SUCCESS';
export const RETRIEVE_THEMATIC_ARTICLE_LIST_FAIL = 'RETRIEVE_THEMATIC_ARTICLES_FAIL';

export const SHOW_BLOCKED_CHAT_POPUP = 'SHOW_BLOCKED_CHAT_POPUP';
export const HIDE_BLOCKED_CHAT_POPUP = 'HIDE_BLOCKED_CHAT_POPUP';


// WEBPACK FOOTER //
// ./src/components/Editions/editionsActionTypes.js